import {useEffect, useState} from 'react'
import {MenuComponent} from '../../../../../../../../_metronic/assets/ts/components'
import {initialQueryState, KTSVG} from '../../../../../../../../_metronic/helpers'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import {useIntl} from 'react-intl'
import axios from 'axios'
import AsyncSelect from 'react-select/async'
import {colourStyles} from '../../../styles/styles'
import moment from 'moment'
import {Calendar} from 'primereact/calendar'
interface UseOption {
  readonly value: string
  readonly label: string
}

const ActionPlansListFilter = () => {
  const intl = useIntl()
  const initSelect = {
    value: '',
    label: intl.formatMessage({id: 'COMMON.ALL'}),
  }
  const {updateState} = useQueryRequest()

  //variaval de controle do filtro avançado
  const [openFilterWin, setOpenFilterWin] = useState<boolean>(false)

  //variaveis de controle de intervalo de datas
  const [openDateConclusion, setOpenDateConclusion] = useState<boolean>(false)
  const [openDateLimit, setOpenDateLimit] = useState<boolean>(false)

  // variaveis do filtro
  //inicio variaveis que usam AsyncSelect
  const [project_obj, setproject_obj] = useState<any | undefined>()
  const [project_id, setproject_id] = useState<string | undefined>()

  const [enterprise_id, setenterprise_id] = useState<string | undefined>()
  // eslint-disable-next-line
  const [, setenterprise_id_obj] = useState<any | undefined>()
  const [license_type_id, setlicense_type_id] = useState<string | undefined>()
  const [license_type_id_obj, setlicense_type_id_obj] = useState<any | undefined>()

  const [license_number, setlicense_number] = useState<string | undefined>()
  const [license_number_obj, setlicense_number_obj] = useState<any | undefined>()

  const [responsible, setresponsible] = useState<string | undefined>()

  const [user_id, setuser_id] = useState<string | undefined>()
  const [user_id_obj, setuser_id_obj] = useState<any | undefined>()

  const [provider_id, setprovider_id] = useState<string | undefined>()
  const [provider_id_obj, setprovider_id_obj] = useState<any | undefined>()
  //fim variaveis que usam AsyncSelect

  //variaveis normais
  const [description, setdescription] = useState<string | undefined>()
  const [status, setstatus] = useState<string | undefined>()
  const [character, setcharacter] = useState<string | undefined>()
  const [tag, settag] = useState<string | undefined>()

  //variaveis de Datas e intervalos de datas
  const [predicted_date, setpredicted_date] = useState<Date | Date[] | undefined>(undefined)
  const [predicted_dateD, setpredicted_dateD] = useState<Date | Date[] | undefined>(undefined)
  const [predicted_date_between, setpredicted_date_between] = useState<Date | Date[] | undefined>(
    undefined
  )
  const [predicted_date_betweenD, setpredicted_date_betweenD] = useState<Date | Date[] | undefined>(
    undefined
  )

  const [conclusion_date, setconclusion_date] = useState<Date | Date[] | undefined>(undefined)
  const [conclusion_dateD, setconclusion_dateD] = useState<Date | Date[] | undefined>(undefined)
  const [conclusion_date_between, setconclusion_date_between] = useState<Date | Date[] | undefined>(
    undefined
  )
  const [conclusion_date_betweenD, setconclusion_date_betweenD] = useState<
    Date | Date[] | undefined
  >(undefined)

  const API_URL = process.env.REACT_APP_API_URL || 'api'

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  // função que reseta os filtros
  const resetData = () => {
    updateState({filter: undefined, ...initialQueryState})
    setprovider_id(undefined)
    setprovider_id_obj(initSelect)
    setuser_id(undefined)
    setuser_id_obj(initSelect)

    setproject_id(undefined)
    setproject_obj(initSelect)
    setenterprise_id(undefined)
    setenterprise_id_obj(initSelect)
    setlicense_type_id(undefined)
    setlicense_type_id_obj(initSelect)
    setlicense_number(undefined)
    setlicense_number_obj(initSelect)
    setresponsible('')
    setdescription(undefined)
    setpredicted_date(undefined)
    setpredicted_dateD(undefined)
    setpredicted_date_between(undefined)
    setpredicted_date_betweenD(undefined)
    setconclusion_date(undefined)
    setconclusion_dateD(undefined)
    setconclusion_date_between(undefined)
    setconclusion_date_betweenD(undefined)
    setdescription('')
    setcharacter('')
    settag('')
  }

  // função que faz a busca dos dados
  const filterData = () => {
    updateState({
      filter: {
        project_id,
        user_id,
        provider_id,
        character,
        status,
        tag,
        responsible,
        license_number,
        license_type_id,
        enterprise_id,
        description,
        predicted_date,
        predicted_date_between,
        conclusion_date,
        conclusion_date_between,
      },
      ...initialQueryState,
    })
  }

  // função que abre o filtro avançado
  const openFilter = () => {
    if (openFilterWin === false) {
      setOpenFilterWin(true)
    } else {
      setOpenFilterWin(false)
    }
  }

  // função que abre o filtro de data conclusão por intervalo
  const openDConclusion = () => {
    if (openDateConclusion === false) {
      setOpenDateConclusion(true)
    } else {
      setOpenDateConclusion(false)
    }
  }

  // função que abre o filtro de data limite por intervalo
  const openDLimit = () => {
    if (openDateLimit === false) {
      setOpenDateLimit(true)
    } else {
      setOpenDateLimit(false)
    }
  }

  //função que busca os dados do projeto do AsyncSelect
  const loadOptionsProjects = (inputValue: string, callback: (options: UseOption[]) => void) => {
    setTimeout(() => {
      getProjects()
      let projects: any = []
      async function getProjects() {
        const {data} = await axios.get(API_URL + '/v1/projects/select2')
        let Response = data.results

        const projectInit: any = {
          value: '',
          label: intl.formatMessage({id: 'COMMON.ALL'}),
        }
        projects.push(projectInit)

        if (Response) {
          for (const element of Response) {
            const project: any = {
              value: element.id,
              label: element.code,
            }
            projects.push(project)
          }
        }
      }
      callback(projects)
    }, 1000)
  }

  //função que altera o valor do projeto no AsyncSelect
  const handleChangeProject = (option: any) => {
    setproject_id(option.value)
    setproject_obj(option)
  }

  //função que busca os dados do tipo de licença do AsyncSelect
  const loadOptionsLicenses_Types = (
    inputValue: string,
    callback: (options: UseOption[]) => void
  ) => {
    setTimeout(() => {
      getlicenses_Types()
      let licenses: any = []
      async function getlicenses_Types() {
        const {data} = await axios.get(API_URL + '/sga/v1/license_types/select2')
        let Response = data.results

        const licenseInit: any = {
          value: '',
          label: intl.formatMessage({id: 'COMMON.ALL'}),
        }
        licenses.push(licenseInit)

        for (const element of Response) {
          const license: any = {
            value: element.id,
            label: element.abbreviate,
          }

          licenses.push(license)
        }
      }
      callback(licenses)
    }, 1000)
  }

  //função que altera o valor do tipo de licença no AsyncSelect
  const handleChangeLicenseType = (option: any) => {
    setlicense_type_id(option.value)
    setlicense_type_id_obj(option)
  }

  //função que busca os dados da licença do AsyncSelect
  const loadOptionsLicenses = (inputValue: string, callback: (options: UseOption[]) => void) => {
    setTimeout(() => {
      getlicense()
      let license: any = []
      async function getlicense() {
        const {data} = await axios.get(API_URL + '/sga/v1/licenses/select2')
        let Response = data.results

        const licenseInit: any = {
          value: '',
          label: intl.formatMessage({id: 'COMMON.ALL'}),
        }
        license.push(licenseInit)

        if (Response) {
          for (const element of Response) {
            const field: any = {
              value: element.id,
              label: element.license_number,
            }

            license.push(field)
          }
        }
      }
      callback(license)
    }, 1000)
  }

  //função que altera o valor da licença no AsyncSelect
  const handleChangeLicense = (option: any) => {
    setlicense_number(option.value)
    setlicense_number_obj(option)
  }

  //função que busca os dados do usuario do AsyncSelect
  const loadOptionsusers = (inputValue: string, callback: (options: UseOption[]) => void) => {
    setTimeout(() => {
      getusers()
      let users: any = []
      async function getusers() {
        const {data} = await axios.get(API_URL + '/v1/users/select2')
        let Response = data.results
        console.log('USER', Response)

        const enterpriseInit: any = {
          value: '',
          label: intl.formatMessage({id: 'COMMON.ALL'}),
        }
        users.push(enterpriseInit)

        if (Response) {
          for (const element of Response) {
            const user: any = {
              value: element.id,
              label: element.username,
            }

            users.push(user)
          }
        }
      }
      callback(users)
    }, 1000)
  }

  //função que Converte a data para o formato do banco de dados no componente DatePicker
  const setConvertDate = (e: any, type: string, period: 'start' | 'conclusion' | 'limit') => {
    switch (period) {
      case 'start': {
        if (type === 'single') {
          let DateFormate: any
          DateFormate = moment(new Date(e)).format('YYYY-MM-DD')
          setpredicted_date(DateFormate)
          setpredicted_dateD(e)
        } else if (type === 'range') {
          let DateFormate: any = []
          if (e.length === 2) {
            DateFormate[0] = moment(new Date(e[0])).format('YYYY-MM-DD')
            DateFormate[1] = moment(new Date(e[1])).format('YYYY-MM-DD')
          }
          setpredicted_date_between(DateFormate)
          setpredicted_date_betweenD(e)
        }
        break
      }
      case 'conclusion': {
        if (type === 'single') {
          let DateFormate: any
          DateFormate = moment(new Date(e)).format('YYYY-MM-DD')
          setconclusion_date(DateFormate)
          setconclusion_dateD(e)
        } else if (type === 'range') {
          let DateFormate: any = []
          if (e.length === 2) {
            DateFormate[0] = moment(new Date(e[0])).format('YYYY-MM-DD')
            DateFormate[1] = moment(new Date(e[1])).format('YYYY-MM-DD')
          }
          setconclusion_date_between(DateFormate)
          setconclusion_date_betweenD(e)
        }
        break
      }
    }
  }

  //função que altera o valor da empresa no AsyncSelect
  const handleChangeusers = (option: any) => {
    setuser_id(option.value)
    setuser_id_obj(option)
  }

  //função que busca os dados do Fornecedor do AsyncSelect
  const loadOptionsproviders = (inputValue: string, callback: (options: UseOption[]) => void) => {
    setTimeout(() => {
      getproviders()
      let providers: any = []
      async function getproviders() {
        const {data} = await axios.get(API_URL + '/v1/providers/select2')
        let Response = data.results
        console.log('provider', Response)

        const enterpriseInit: any = {
          value: '',
          label: intl.formatMessage({id: 'COMMON.ALL'}),
        }
        providers.push(enterpriseInit)

        if (Response) {
          for (const element of Response) {
            const provider: any = {
              value: element.id,
              label: element.name,
            }

            providers.push(provider)
          }
        }
      }
      callback(providers)
    }, 1000)
  }
  //função que altera o valor da empresa no AsyncSelect
  const handleChangeproviders = (option: any) => {
    setprovider_id(option.value)
    setprovider_id_obj(option)
  }

  return (
    <>
      <div className='card-body p-5 pb-5 mt-3 '>
        {/* INICIO LINHA FIXA DO FILTRO */}
        <div className='row'>
          <div className='col-lg-3'>
            <label className='form-label fs-7 fw-bold'>
              {intl.formatMessage({id: 'PROJECT.PROJECT_PLURAL'})}
            </label>
            <div className='d-flex align-items-center position-relative my-1'>
              <AsyncSelect
                className='form-control form-control-solid fs-7 p-1 ps-3'
                data-kt-license-table-filter='project_id'
                styles={colourStyles}
                cacheOptions
                loadOptions={loadOptionsProjects}
                onChange={(e: any) => handleChangeProject(e)}
                value={project_obj}
                filterOption={(option, inputValue) =>
                  option.label
                    ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                    : false
                }
                defaultOptions
                placeholder={
                  intl.formatMessage({id: 'COMMON.SEARCH'}) +
                  ' ' +
                  intl.formatMessage({id: 'PROJECT.PROJECT_PLURAL'})
                }
              />
            </div>
          </div>

          {/* filtro de numero da licença  */}
          <div className='col-lg-4'>
            <label className='form-label fs-7 fw-bold'>
              {intl.formatMessage({id: 'CONDITIONINGS.LICENSE_NUMBER'})}
            </label>
            <div className='d-flex align-items-center position-relative my-1'>
              <AsyncSelect
                className='form-control form-control-solid fs-7 p-1 ps-3'
                data-kt-license-table-filter='license_number'
                styles={colourStyles}
                cacheOptions
                loadOptions={loadOptionsLicenses}
                filterOption={(option, inputValue) =>
                  option.label
                    ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                    : false
                }
                defaultOptions
                placeholder={
                  intl.formatMessage({id: 'COMMON.SEARCH'}) +
                  ' ' +
                  intl.formatMessage({id: 'CONDITIONINGS.LICENSE_NUMBER'})
                }
                onChange={(e: any) => handleChangeLicense(e)}
                value={license_number_obj}
              />
            </div>
          </div>

          {/* filtro de tipo de numero da condicionante  */}
          <div className='col-lg-5'>
            <label className='form-label fs-7 fw-bold'>N° da Condicionante</label>
            <div className='d-flex align-items-center position-relative my-1'>
              <AsyncSelect
                className='form-control form-control-solid fs-7 p-1 ps-3'
                data-kt-license-table-filter='conditioning_number'
                styles={colourStyles}
                cacheOptions
                loadOptions={loadOptionsLicenses_Types}
                filterOption={(option, inputValue) =>
                  option.label
                    ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                    : false
                }
                defaultOptions
                placeholder={
                  // eslint-disable-next-line
                  intl.formatMessage({id: 'COMMON.SEARCH'}) + ' ' + 'N° da Condicionante'
                  // intl.formatMessage({id: 'LICENSES.TYPE'})
                }
                onChange={(e: any) => handleChangeLicenseType(e)}
                value={license_type_id_obj}
              />
              <button
                type='button'
                className='btn btn-sm btn-icon btn-light-primary btn-active-primary p-3 m-1'
                onClick={openFilter}
                title='Mais Filtros'
              >
                <i className='bi bi-sliders2-vertical fs-2' />
              </button>
              <button
                type='button'
                className='btn btn-sm btn-icon btn-light-danger p-3 m-1'
                onClick={resetData}
                title='Limpar Busca'
              >
                <KTSVG path='/media/icons/duotune/art/art004.svg' className='svg-icon-3' />
              </button>
              <button
                type='button'
                className='btn btn-sm btn-primary m-1'
                onClick={filterData}
                title='Filtar'
              >
                {intl.formatMessage({id: 'COMMON.SEARCH'})}
              </button>
            </div>
          </div>
        </div>

        {/* FIM LINHA 1 FIXA DO FILTRO */}

        {/* INICIO FILTRO RETRATIL FIXA DO FILTRO */}

        {/*INICIO LINHA 2 */}
        {openFilterWin && (
          <div className='row mt-2'>
            {/* filtro de status */}
            <div className='col-lg-4'>
              <label className='form-label fs-7 fw-bold'>
                {intl.formatMessage({id: 'COMMON.STATUS'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <select
                  className='form-select form-select-solid fs-7 ps-6'
                  data-kt-select2='true'
                  data-kt-user-table-filter='status'
                  onChange={(e) => setstatus(e.target.value)}
                  value={status}
                >
                  <option value=''>{intl.formatMessage({id: 'COMMON.ALL'})}</option>
                  <option value='not_started'>
                    {intl.formatMessage({id: 'COMMON.NOT_STARTED'})}
                  </option>
                  <option value='in_progress'>
                    {intl.formatMessage({id: 'COMMON.IN_PROGRESS'})}
                  </option>
                  <option value='finished'>{intl.formatMessage({id: 'COMMON.FINISHED'})}</option>
                  <option value='expired'>{intl.formatMessage({id: 'COMMON.EXPIRED'})}</option>
                  <option value='waiting_answer'>
                    {intl.formatMessage({id: 'COMMON.WAITING_ANSWER'})}
                  </option>
                </select>
              </div>
            </div>
            {/* fim filtro STATUS   */}

            {/* inicio filtro de data de PREVISÃO   */}
            {/* data simples  */}
            {openDateLimit === false && (
              <div className='col-lg-4'>
                <label className='form-label fs-7 fw-bold'>
                  {intl.formatMessage({id: 'COMMON.PREDICTED_DATE'})}
                </label>
                <div className='d-flex align-items-center position-relative my-1'>
                  <Calendar
                    data-kt-user-table-filter='predicted_dateD'
                    value={predicted_dateD}
                    onChange={(e) => setConvertDate(e.value, 'single', 'start')}
                    selectionMode='single'
                    inputClassName='form-control form-control-solid fs-6 ps-6 border border-white'
                    style={{
                      width: '100%',
                    }}
                    placeholder='dd/mm/aa'
                    showButtonBar
                    dateFormat='dd/mm/yy'
                  />

                  <button
                    type='button'
                    className='btn btn-sm btn-icon btn-primary m-1'
                    onClick={openDLimit}
                    title='selecionar intervalo'
                  >
                    <KTSVG
                      path='/media/icons/duotune//general/gen019.svg'
                      className='svg-icon-2 svg-icon-light'
                    />
                  </button>
                </div>
              </div>
            )}
            {/* data intervalo */}
            {openDateLimit === true && (
              <div className='col-lg-4'>
                <label className='form-label fs-7 fw-bold'>
                  {intl.formatMessage({id: 'COMMON.PREDICTED_DATE'})}
                </label>
                <div className='d-flex align-items-center position-relative my-1'>
                  <Calendar
                    data-kt-user-table-filter='predicted_date_betweenD'
                    value={predicted_date_betweenD}
                    onChange={(e) => setConvertDate(e.value, 'range', 'start')}
                    selectionMode='range'
                    inputClassName='form-control form-control-solid fs-6 ps-6 border border-white'
                    style={{
                      width: '100%',
                    }}
                    dateFormat='dd/mm/yy'
                    placeholder='dd/mm/aa - dd/mm/aa'
                    showButtonBar
                  />
                  <button
                    type='button'
                    className='btn btn-sm btn-icon btn-primary m-1'
                    onClick={openDLimit}
                    title={intl.formatMessage({id: 'CONDITIONINGS.SELECT_INTERVAL'})}
                  >
                    <KTSVG
                      path='/media/icons/duotune//general/gen019.svg'
                      className='svg-icon-2 svg-icon-light'
                    />
                  </button>
                </div>
              </div>
            )}
            {/* fim filtro de data de limite */}

            {/* inicio filtro de data de conclusão */}
            {/* data simples  */}
            {openDateConclusion === false && (
              <div className='col-lg-4'>
                <label className='form-label fs-7 fw-bold'>
                  {intl.formatMessage({id: 'COMMON.CONCLUSION_DATE'})}
                </label>
                <div className='d-flex align-items-center position-relative my-1'>
                  <Calendar
                    data-kt-user-table-filter='conclusion_dateD'
                    value={conclusion_dateD}
                    onChange={(e) => setConvertDate(e.value, 'single', 'conclusion')}
                    selectionMode='single'
                    inputClassName='form-control form-control-solid fs-6 ps-6 border border-white'
                    style={{
                      width: '100%',
                    }}
                    dateFormat='dd/mm/yy'
                    placeholder='dd/mm/aa'
                    showButtonBar
                  />
                  <button
                    type='button'
                    className='btn btn-sm btn-icon btn-primary m-1'
                    onClick={openDConclusion}
                    title={intl.formatMessage({id: 'CONDITIONINGS.SELECT_INTERVAL'})}
                  >
                    <KTSVG
                      path='/media/icons/duotune//general/gen019.svg'
                      className='svg-icon-2 svg-icon-light'
                    />
                  </button>
                </div>
              </div>
            )}
            {/* data intervalo */}
            {openDateConclusion === true && (
              <div className='col-lg-4'>
                <label className='form-label fs-7 fw-bold'>
                  {intl.formatMessage({id: 'COMMON.CONCLUSION_DATE'})}
                </label>
                <div className='d-flex align-items-center position-relative my-1'>
                  <Calendar
                    data-kt-user-table-filter='predicted_date_betweenD'
                    value={conclusion_date_betweenD}
                    onChange={(e) => setConvertDate(e.value, 'range', 'conclusion')}
                    selectionMode='range'
                    inputClassName='form-control form-control-solid fs-6 ps-6 border border-white'
                    style={{
                      width: '100%',
                    }}
                    dateFormat='dd/mm/yy'
                    placeholder='dd/mm/aa - dd/mm/aa'
                    showButtonBar
                  />
                  <button
                    type='button'
                    className='btn btn-sm btn-icon btn-primary m-1'
                    onClick={openDConclusion}
                    title={intl.formatMessage({id: 'CONDITIONINGS.SELECT_INTERVAL'})}
                  >
                    <KTSVG
                      path='/media/icons/duotune//general/gen019.svg'
                      className='svg-icon-2 svg-icon-light'
                    />
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
        {/* fim filtro de data */}
        {/* FIM LINHA 2 */}

        {/*INICIO LINHA 3 */}
        {openFilterWin && (
          <div className='row mt-2'>
            {/* filtro de descrição */}
            <div className='col-lg-3'>
              <label className='form-label fs-7 fw-bold'>
                {intl.formatMessage({id: 'COMMON.DESCRIPTION'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <input
                  type='text'
                  data-kt-user-table-filter='description'
                  className='form-control form-control-solid fs-7  ps-6'
                  placeholder={
                    intl.formatMessage({id: 'COMMON.SEARCH'}) +
                    ' ' +
                    intl.formatMessage({id: 'COMMON.DESCRIPTION'})
                  }
                  onChange={(e: any) => setdescription(e.target.value)}
                  value={description}
                />
              </div>
            </div>

            {/* inicio filtro de responsavel */}
            <div className='col-lg-3'>
              <label className='form-label fs-7 fw-bold'>
                {intl.formatMessage({id: 'COMMON.RESPONSIBLE'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <input
                  type='text'
                  data-kt-user-table-filter='responsible'
                  className='form-control form-control-solid fs-7 ps-6'
                  placeholder={
                    intl.formatMessage({id: 'COMMON.SEARCH'}) +
                    ' ' +
                    intl.formatMessage({id: 'COMMON.RESPONSIBLE'})
                  }
                  onChange={(e: any) => setresponsible(e.target.value)}
                  value={responsible}
                />
              </div>
            </div>

            {/* filtro de tipo de usuario  */}
            <div className='col-lg-3'>
              <label className='form-label fs-7 fw-bold'>
                {intl.formatMessage({id: 'USERS.TITLE'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <AsyncSelect
                  className='form-control form-control-solid fs-7 p-1 ps-3'
                  data-kt-license-table-filter='user_id'
                  styles={colourStyles}
                  cacheOptions
                  loadOptions={loadOptionsusers}
                  filterOption={(option, inputValue) =>
                    option.label
                      ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                      : false
                  }
                  defaultOptions
                  placeholder={
                    intl.formatMessage({id: 'COMMON.SEARCH'}) +
                    ' ' +
                    intl.formatMessage({id: 'USERS.TITLE'})
                  }
                  onChange={(e: any) => handleChangeusers(e)}
                  value={user_id_obj}
                />
              </div>
            </div>

            {/* filtro de tipo de fornecedor  */}
            <div className='col-lg-3'>
              <label className='form-label fs-7 fw-bold'>
                {intl.formatMessage({id: 'PROVIDER.TITLE'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <AsyncSelect
                  className='form-control form-control-solid fs-7 p-1 ps-3'
                  data-kt-license-table-filter='provider_id'
                  styles={colourStyles}
                  cacheOptions
                  loadOptions={loadOptionsproviders}
                  filterOption={(option, inputValue) =>
                    option.label
                      ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                      : false
                  }
                  defaultOptions
                  placeholder={
                    intl.formatMessage({id: 'COMMON.SEARCH'}) +
                    ' ' +
                    intl.formatMessage({id: 'PROVIDER.TITLE'})
                  }
                  onChange={(e: any) => handleChangeproviders(e)}
                  value={provider_id_obj}
                />
              </div>
            </div>
          </div>
        )}
        {/* FIM LINHA 3 */}
      </div>
    </>
  )
}

export {ActionPlansListFilter}
